import React from 'react';
import useBoneBackgroundColor from 'Hooks/useBoneBackgroundColor';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import { useSnackbarContext } from 'Context/SnackbarContext';
import { usePageContentContext } from 'Views/Page/Contexts/PageContentContext';
import { RequestConfirmation } from 'Organisms/RequestConfirmationPage';
import useEventTrackingLogEvent, { categories, eventSubTypes, eventTypes } from 'EventTracking/useEventTrackingLogEvent';

export const Layout = () => {
  const { resource } = useMetaLayoutContext();
  const [loading, setLoading] = React.useState(false);
  const { displayErrorMessage } = useSnackbarContext();
  const { loadPageContentLink } = usePageContentContext();
  const { logStandardizedEvent } = useEventTrackingLogEvent();

  React.useEffect(() => {
    logStandardizedEvent(categories.upgrade, eventTypes.page, eventSubTypes.impression, {
      eventProperties: {
        householdId: resource.attr('householdId'),
        action: 'upgrade-confirmation',
      },
    });
  }, [resource.link('self').url()]);

  useBoneBackgroundColor();

  const onClick = (rel) => {
    setLoading(true);
    try {
      loadPageContentLink(rel.link('related'));
      // We don't need to set loading back to true because this component will unmount
    } catch (err) {
      setLoading(false);
      displayErrorMessage(err, 'Unable to navigate to dashboard');
    }
  };

  return (
    <RequestConfirmation resource={resource} onClick={onClick} loading={loading} />
  );
};
